export const COMPILE_OBJECT_HISTORY = '@@epic/COMPILE_OBJECT_HISTORY';
